(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["og-home-worlds-clarity-base"] && !Shopify.designMode) return;
  try {
    const trustpilotLink = document.getElementById('og-home-trustpilot-link');
  const brandReasons = document.querySelector('.og-sales-home__reasons');

  if (trustpilotLink && brandReasons) {
    brandReasons.insertAdjacentElement('afterend', trustpilotLink);
    trustpilotLink.hidden = false;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["og-home-worlds-clarity"] && !Shopify.designMode) return;
  try {
    const trustpilotLocalizedLink = document.getElementById('og-home-trustpilot-link');
  const storefrontLanguage = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
  const trustpilotLocalizedUrls = {
    de: 'https://de.trustpilot.com/review/overlanding-gear.de',
    en: 'https://www.trustpilot.com/review/overlanding-gear.de',
    fr: 'https://fr.trustpilot.com/review/overlanding-gear.de',
    it: 'https://it.trustpilot.com/review/overlanding-gear.de',
    es: 'https://es.trustpilot.com/review/overlanding-gear.de'
  };

  if (trustpilotLocalizedLink) {
    trustpilotLocalizedLink.href = trustpilotLocalizedUrls[storefrontLanguage] || trustpilotLocalizedUrls.de;
  }
  } catch(e) { console.error(e); }
})();

})();
